import React, { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const InputSearch = ({
  value: externalValue,
  onChange,
  onSearch,
  placeholder = "Search...",
  label,
  showLabel = true,
  className = "",
  isDisabled = false,
  isRequired = false,
  buttonText = "Search",
  ...props
}) => {
  const [internalValue, setInternalValue] = useState("");
  
  // Use external value if provided, otherwise use internal state
  const value = externalValue !== undefined ? externalValue : internalValue;
  
  // Use external onChange if provided, otherwise use internal setter
  const handleChange = onChange || ((e) => setInternalValue(e.target.value));

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className={className}>
      {showLabel && label && (
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className={showLabel && label ? "mt-2" : ""}>
        <div className="flex rounded-md shadow-sm">
          <div className="relative flex flex-grow items-stretch focus-within:z-10">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
            <input
              type="text"
              value={value}
              onChange={handleChange}
              onKeyDown={handleKeyPress}
              placeholder={placeholder}
              disabled={isDisabled}
              className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
              {...props}
            />
          </div>
          <button
            type="button"
            onClick={handleSearchClick}
            disabled={isDisabled}
            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputSearch; 